<script setup>
import config from '@/common/config'
import { get, postMultipart, qsel, toJson } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import { useMetaStore } from '@/stores'
import { reactive } from 'vue'
const meta=reactive({heads:['site_nm','com_nm','com_addr','ceo','business_reg_num','mail_order_number','favicon','logo','logo_front']
  ,data:{}}),metaStore=useMetaStore()
,pop=async(type)=>{
  meta.poptype=null
  metaStore.pop({ison:true,callback:() =>meta.poptype=type})
},save=async()=>{
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/admin/modcompanyinfos',meta.data)
  metaStore.blockLoading(false)
  metaStore.toastKey('thesaveiscomplete')
  search()
},search=async()=>{
  meta.onsearch=true
  meta.data={delfavicon:false,dellogo:false}
  delete meta.faviconurl
  delete meta.logourl
  delete meta.logo_fronturl
  metaStore.faviconurl=config.backend+'favicon.ico'
  metaStore.logourl=config.backend+'logo.png'
  metaStore.logo_fronturl=config.backend+'logo_front.png'
  metaStore.blockLoading()
  const res=await get('rest/public/companyinfos')
  metaStore.blockLoading(false)
  res.data.forEach(info=>meta.data[info.wkey]=info.sval)
  if(meta.data.favicon){
    delete meta.data.favicon
    metaStore.faviconurl=config.backend+'favicon'
    meta.faviconurl=metaStore.faviconurl
    qsel('[rel=icon]').href=metaStore.faviconurl
  }
  if(meta.data.logo){
    delete meta.data.logo
    metaStore.logourl=config.backend+'logo'
    meta.logourl=metaStore.logourl
  }
  if(meta.data.logo_front){
    delete meta.data.logo_front
    metaStore.logo_fronturl=config.backend+'logo_front'
    meta.logo_fronturl=metaStore.logo_fronturl
  }
  meta.onsearch=false
}
search()
</script>
<template>
  <v-card flat class="admcominfo">
    <v-card-title>{{ $t('man_com_info') }}</v-card-title>
    <v-card-text>
      <v-table v-if="!meta.onsearch">
        <tbody>
          <tr v-for="head in meta.heads">
            <th style="width: 150px;">{{ head=='favicon'?`${$t(head)}(${$t('logo')})`:$t(head) }}</th>
            <td>
              <v-text-field v-if="head!='favicon'&&head!='logo'&&head!='logo_front'" hide-details variant="outlined" density="compact" v-model="meta.data[head]"/>
              <div v-if="head=='favicon'">
                <img v-if="meta.faviconurl" class="ma-5" style="max-width: 300px;max-height: 300px;" :src="meta.faviconurl"/>
                <v-file-input show-size hide-details variant="outlined" density="compact" class="mt-3" :label="$t('fileattachments')" v-model="meta.data.favicon"/>
                <v-checkbox hide-details :label="'기존 파비콘 삭제'" v-model="meta.data.delfavicon" :disabled="meta.data.favicon!=null"/>
              </div>
              <div v-if="head=='logo'">
                <img v-if="meta.logourl" class="ma-5" style="max-width: 300px;max-height: 300px;" :src="meta.logourl"/>
                <v-file-input show-size hide-details variant="outlined" density="compact" class="mt-3" :label="$t('fileattachments')" v-model="meta.data.logo"/>
                <v-checkbox hide-details :label="'기존 로고 삭제'" v-model="meta.data.dellogo" :disabled="meta.data.logo!=null"/>
              </div>
              <div v-if="head=='logo_front'">
                <img v-if="meta.logo_fronturl" class="ma-5" style="max-width: 300px;max-height: 300px;" :src="meta.logo_fronturl"/>
                <v-file-input show-size hide-details variant="outlined" density="compact" class="mt-3" :label="$t('fileattachments')" v-model="meta.data.logo_front"/>
                <v-checkbox hide-details :label="'기존 첫화면 대형로고 삭제'" v-model="meta.data.dellogo_front" :disabled="meta.data.logo_front!=null"/>
              </div>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
    <v-card-actions>
      <v-row justify="end">
        <v-col></v-col>
        <v-col cols="2"><v-btn block variant="elevated" :text="$t('refresh')" @click="search"/></v-col>
        <v-col cols="2" class="pe-5"><v-btn block color="primary" variant="elevated" :text="$t('save')" @click="pop('save')"/></v-col>
      </v-row>
    </v-card-actions>
  </v-card>
  <Teleport v-if="meta.poptype" to="#popbody">
    <ConfirmCard :ttl="$t('man_com_info')" :cont="$t('save_con')" @cancel="metaStore.pop({ison:false})" @confirm="save"/>
  </Teleport>
</template>
<style>
.admcominfo table{border: 1px solid #e0e0e0;}
.admcominfo th{background-color: #eee;text-align: center !important;}
</style>
